import api from './api';

export async function getClients(search = '') {
  const { data } = await api.get('/client', { params: search ? { search } : {} });
  return data;
}

export async function getClientByDocument(nationality, document) {
  const { data } = await api.get(`/client/document/${nationality}/${encodeURIComponent(document)}`);
  return data;
}

export async function createClient(payload) {
  const { data } = await api.post('/client', payload);
  return data;
}

export async function updateClient(id, payload) {
  const { data } = await api.put(`/client/${id}`, payload);
  return data;
}

export async function changeStateClient(id) {
  const { data } = await api.get(`/client/change-state/${id}`);
  return data;
}
